import React from "react";
import { Typography } from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  InfoOutlined as InfoOutlinedIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { DealerProps } from "store/modules/DealerCare/types.store";
import * as Styled from "./styles";

const SCHEDULE_SERVICE =
  "O Agendamento permite o usuário realizar o agendamento da entrega, através do Whatsapp, quando a revenda estiver fora do horário de funcionamento.";

// const SUPER_RECOLHE_SERVICE =
//   "A iniciativa Super Recolhe está sendo implementada em algumas revendas com o objetivo de incentivar o recolhimento responsável de óleo usado.";

const ONLINE_PAYMENT_SERVICE =
  "Quando ativo, a revenda pode oferecer pagamento online aos clientes no fluxo de compra, com adquirência e configurações de pagamento no aplicativo.";

const GAS_DO_POVO_SERVICE =
  "O Gás do Povo é um programa do Governo Federal que oferece gás a preço acessível para famílias de baixa renda. Apenas revendas selecionadas e habilitadas com a máquina da Caixa podem disponibilizar esta função.";

export interface DealerServicesProps {
  dealerData: DealerProps | null;
}

function DealerServices({ dealerData }: DealerServicesProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Styled.ServicesListContainer>
      <Typography variant="body2" color="#000000" sx={{ fontSize: 12 }}>
        Serviços
      </Typography>
      {/* <Styled.ServicesRow>
        <CheckCircleIcon
          fontSize="small"
          color={dealerData?.attributes?.superRecolhe ? "success" : "action"}
        />
        <Typography variant="body1" color="#000000">
          Super Recolhe
        </Typography>
        <Styled.ServicesTooltip title={SUPER_RECOLHE_SERVICE} placement="right">
          <InfoOutlinedIcon />
        </Styled.ServicesTooltip>
      </Styled.ServicesRow> */}

      <Styled.ServicesRow>
        <CheckCircleIcon
          fontSize="small"
          color={dealerData?.attributes?.gasDoPovo ? "success" : "action"}
        />
        <Typography variant="body1" color="#000000">
          Gás do Povo
        </Typography>
        <Styled.ServicesTooltip
          title={GAS_DO_POVO_SERVICE}
          placement="right"
          componentsProps={{
            tooltip: { sx: Styled.servicesTooltipSx },
          }}
        >
          <InfoOutlinedIcon />
        </Styled.ServicesTooltip>
      </Styled.ServicesRow>
      <Styled.ServicesRow>
        <CheckCircleIcon
          fontSize="small"
          color={
            dealerData?.attributes?.schedulingEnabled ? "success" : "action"
          }
        />
        <Typography variant="body1" color="#000000">
          Agendamento
        </Typography>
        <Styled.ServicesTooltip
          title={SCHEDULE_SERVICE}
          placement="right"
          componentsProps={{
            tooltip: { sx: Styled.servicesTooltipSx },
          }}
        >
          <InfoOutlinedIcon />
        </Styled.ServicesTooltip>
      </Styled.ServicesRow>
      <Styled.ServicesRow>
        <CheckCircleIcon
          fontSize="small"
          color={
            dealerData?.attributes?.onlinePaymentEnabled ? "success" : "action"
          }
        />
        <Typography variant="body1" color="#000000">
          {t("onlinePayment")}
        </Typography>
        <Styled.ServicesTooltip
          title={ONLINE_PAYMENT_SERVICE}
          placement="right"
          componentsProps={{
            tooltip: { sx: Styled.servicesTooltipSx },
          }}
        >
          <InfoOutlinedIcon />
        </Styled.ServicesTooltip>
      </Styled.ServicesRow>
    </Styled.ServicesListContainer>
  );
}

export default DealerServices;
